import React from "react";
import "./FilterConfirmation.css";

export default function ModPackFilterConfirmation(props) {
  const {
    addChannelLabel,
    addChannelListData,
    addPackLabel,
    addPackListData,
    dropChannelLabel,
    dropChannelListData,
    dropPackLabel,
    dropPackListData,
  } = props;
  console.log(
    props,
    addChannelListData.length !== 0 && addChannelLabel !== undefined,
    addPackListData.length !== 0 && addPackLabel !== undefined,
    "check here now"
  );

  return (
    <>
      {(addChannelListData.length !== 0 && addChannelLabel !== undefined) ||
      (addPackListData.length !== 0 && addPackLabel !== undefined) ? (
        <div style={{ fontFamily: "VoltePlay-Medium" }}>
          <div
            className="confirmationContainer"
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <span className="packs-img">
              {localStorage.getItem("userName").toString()?.substr(1, 2)}
            </span>{" "}
            <span
              className="confirmation-text"
              style={{
                maxWidth: "97%",
                display: "flex",
                flexDirection: "column",
                paddingBottom: "-10%",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                marginTop: "1%",
              }}
            >
              {addChannelLabel && addChannelListData.length !== 0 ? (
                <div>
                  <h4 style={{ fontWeight: "600" }}>{addChannelLabel}</h4>
                  <div className="messageDataContainer">
                    {addChannelListData.length !== 0 ? (
                      addChannelListData.map((oneData) => (
                        <p>
                          {props.from !== "A58" ? oneData.name : oneData}{" "}
                          {props.from !== "A58" ? ":" : null}{" "}
                          {props.from !== "A58" ? oneData.description : null}
                        </p>
                      ))
                    ) : (
                      <p>None</p>
                    )}{" "}
                  </div>
                </div>
              ) : null}
              {addPackLabel && addPackListData.length !== 0 ? (
                <div>
                  <h4 style={{ fontWeight: "600" }}>{addPackLabel}</h4>
                  <div className="messageDataContainer">
                    {addPackListData.map((oneData) => (
                      <p>
                        {props.from !== "A58" ? oneData.name : oneData}{" "}
                        {props.from !== "A58" ? ":" : null}{" "}
                        {props.from !== "A58" ? oneData.description : null}
                      </p>
                    ))}{" "}
                  </div>
                </div>
              ) : null}
            </span>
          </div>
        </div>
      ) : null}
      {(dropChannelListData.length !== 0 && dropChannelLabel !== undefined) ||
      (dropPackListData.length !== 0 && dropPackLabel !== undefined) ? (
        <div style={{ fontFamily: "VoltePlay-Medium", marginTop: "10px" }}>
          <div
            className="confirmationContainer"
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <span className="packs-img">
              {localStorage.getItem("userName").toString()?.substr(1, 2)}
            </span>{" "}
            <span
              className="confirmation-text"
              style={{
                maxWidth: "97%",
                display: "flex",
                flexDirection: "column",
                paddingBottom: "-10%",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                marginTop: "1%",
              }}
            >
              {dropChannelLabel && dropChannelListData.length !== 0 ? (
                <div>
                  <h4 style={{ fontWeight: "600" }}>{dropChannelLabel}</h4>
                  <div className="messageDataContainer">
                    {dropChannelListData.length !== 0 ? (
                      dropChannelListData.map((oneData) => (
                        <p>
                          {props.from !== "A58" ? oneData.name : oneData}{" "}
                          {props.from !== "A58" ? ":" : null}{" "}
                          {props.from !== "A58" ? oneData.description : null}
                        </p>
                      ))
                    ) : (
                      <p>None</p>
                    )}{" "}
                  </div>
                </div>
              ) : null}
              {dropPackLabel && dropPackListData.length !== 0 ? (
                <div>
                  <h4 style={{ fontWeight: "600" }}>{dropPackLabel}</h4>
                  <div className="messageDataContainer">
                    {dropPackListData.map((oneData) => (
                      <p>
                        {props.from !== "A58" ? oneData.name : oneData}{" "}
                        {props.from !== "A58" ? ":" : null}{" "}
                        {props.from !== "A58" ? oneData.description : null}
                      </p>
                    ))}{" "}
                  </div>
                </div>
              ) : null}
            </span>
          </div>
        </div>
      ) : null}
    </>
  );
}
